export enum EDocumentEvent {
  Reviewed = 'reviewed',
  Viewed = 'viewed',
  Rejected = 'rejected',
  Forwarded = 'forwarded',
  Printed = 'printed',
  Downloaded = 'downloaded',
}
